import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { roundDoubleNumbers } from '../../helpers/currency';

interface CartProductPriceProps {
  price?: number;
  isSmallFont?: boolean;
}

export function FriendsBadge({ price, isSmallFont }: CartProductPriceProps) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        backgroundColor: 'secondary.main',
        borderRadius: '10px',
        color: 'secondary.contrastText',
        pb: '2px',
        px: '5px',
        fontSize: isSmallFont ? '14px' : '16px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        fontWeight: '600',
      }}
    >
      {t('services:priceToFriends')}
      {price && (
        <Box
          sx={{
            fontSize: isSmallFont ? '14px' : '19px',
            width: '75px',
            textAlign: 'right',
          }}
        >
          {roundDoubleNumbers(price)} €
        </Box>
      )}
    </Box>
  );
}

export default FriendsBadge;
